import { render, staticRenderFns } from "./messages-notifications-config.vue?vue&type=template&id=76bf1bc2&"
import script from "./messages-notifications-config.vue?vue&type=script&lang=js&"
export * from "./messages-notifications-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports